module.exports = __webpack_public_path__ + "img/Penta5_Regular.f37a6d18.png";